import { Checkbox, Divider, FormControlLabel } from '@mui/material';
import { Dayjs } from 'dayjs';
import { ChangeEvent, Dispatch, FC, SetStateAction, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { StandEntityType } from '@pages/stands/types';
import { DateTimeValidationError } from '@mui/x-date-pickers';
import { AccessEnum } from '@shared/types';
import StandOptionsForm from '@pages/stands/components/StandOptionsForm';

interface DeployThirdStepProps {
    isCurrentStep: boolean;
    standExpireDateTime: Dayjs;
    setStandExpireDateTime: Dispatch<SetStateAction<Dayjs>>;
    setStandExpireDateError: Dispatch<SetStateAction<DateTimeValidationError>>;
    access: AccessEnum;
    setAccess: Dispatch<SetStateAction<AccessEnum>>;
    navigateToStandOrTestrun: boolean;
    setNavigateToStandOrTestrun: Dispatch<SetStateAction<boolean>>;
    entityType: StandEntityType;
    comment: string;
    setComment: Dispatch<SetStateAction<string>>;
    showDateTimePicker?: boolean;
}

const DeployThirdStep: FC<DeployThirdStepProps> = ({
    isCurrentStep,
    standExpireDateTime,
    setStandExpireDateTime,
    setStandExpireDateError,
    access,
    setAccess,
    navigateToStandOrTestrun,
    setNavigateToStandOrTestrun,
    entityType,
    comment,
    setComment,
    showDateTimePicker,
}) => {
    const { t } = useTranslation();

    const handleChangeNavigateToStandOrTestrun = useCallback(
        (_e: ChangeEvent, newChecked: boolean) => {
            setNavigateToStandOrTestrun(newChecked);
        },
        [setNavigateToStandOrTestrun],
    );

    const handleChangeComment = (newComment: string) => {
        setComment(newComment);
    };

    return (
        <StandOptionsForm
            expiresAt={standExpireDateTime}
            onExpiresAtChange={setStandExpireDateTime}
            access={access}
            onAccessChange={setAccess}
            comment={comment}
            onCommentChange={handleChangeComment}
            onError={setStandExpireDateError}
            extraFields={
                <>
                    <Divider flexItem />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={navigateToStandOrTestrun}
                                onChange={handleChangeNavigateToStandOrTestrun}
                            />
                        }
                        label={
                            entityType === 'scheme'
                                ? t('go_to_stand_after_closing_this_dialog')
                                : t('go_to_testrun_after_closing_this_dialog')
                        }
                        sx={{ alignSelf: 'flex-start' }}
                    />
                </>
            }
            rootSx={{
                display: isCurrentStep ? 'flex' : 'none',
            }}
            hideExpiresAtInput={!showDateTimePicker}
        />
    );
};

export default DeployThirdStep;
